import PendingUploads from './PendingUploads';

export default PendingUploads;
